import React from 'react';
import { SERVED_INDUSTRIES } from '../mock';

export default function Industries() {
  return (
    <section className="py-16 sm:py-20 lg:py-24" style={{ backgroundColor: '#efeaff' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="uppercase tracking-[0.16em] text-[11px] sm:text-xs font-semibold mb-3 sm:mb-4" style={{ color: '#5132d4' }}>Who we serve</p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight max-w-4xl" style={{ color: '#130F28' }}>
          Built for businesses <span className="italic" style={{ color: '#5132d4' }}>serious about growth.</span>
        </h2>
        <p className="mt-4 sm:mt-5 max-w-3xl text-base sm:text-lg" style={{ color: '#3b3656' }}>
          If you have customers worth keeping, referrals worth earning, and a business worth growing, Crush was built for you. We work across every industry where relationships and reputation drive revenue.
        </p>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {SERVED_INDUSTRIES.map((i) => (
            <article key={i.name} className="tile rounded-2xl p-6 bg-white border" style={{ borderColor: 'rgba(107,75,239,0.15)' }}>
              <div className="text-3xl mb-3" aria-hidden="true">{i.emoji}</div>
              <h3 className="font-serif text-xl" style={{ color: '#130F28' }}>{i.name}</h3>
              <p className="text-sm mt-2 leading-relaxed" style={{ color: '#3b3656' }}>{i.desc}</p>
            </article>
          ))}
        </div>

        <p className="text-center mt-12 max-w-3xl mx-auto text-sm" style={{ color: '#3b3656' }}>
          <span className="font-semibold" style={{ color: '#130F28' }}>Don't see your industry?</span> If your business grows through repeat customers, referrals, or local reputation, we'd love to talk.
        </p>
      </div>
    </section>
  );
}
